"use strict";
checkList.classy.controller({
    name: 'IncomeNotVerifiedController',
    inject: ['$scope', 'ApplicationService'],
    init: function ()
    {
        this.$.setAnswer(65);
    },
    incomeNotVerifiedComplete: function()
    {
        var caseNo = "case65";
        var caseVal = 0;
        var queue = [];
        if (this.$.answer.incomeNotVerified == 0)
            caseVal = 1;
        this.$.alertPut(queue, caseNo, caseVal, this.$.answer);
    }
});
